module.exports = __webpack_public_path__ + "static/media/scene-banner.c74e488b.png";